export default "https://statics.cloudfastin.top/static/v1.27.18.3/store/images/eeeBay.png?9eb276194841784ab5e6601166bacf5f";